import myAPI from './resources'
import config from '../config'
import carbuyservice from './clients/carBuyService'

export default {
    saveStep1: async function (data) {
        return await carbuyservice.post('/wizard/Step1', data, true);
    },
    saveStep2: async function (data) {
        return await carbuyservice.post('/wizard/Step2', data, true);
    },
    saveDisposition: async function (data) {
        return await carbuyservice.post('/wizard/SaveDisposition', data, true);
    },
    saveStep6: async function (data) {
        return await carbuyservice.post('/wizard/Step6', data, true);
    },
    saveStep8: async function (data) {
        return await carbuyservice.post('/wizard/Step8', data, true);
    },
    saveOffer: async function (data) {
        return await carbuyservice.post('/wizard/SaveOffer', data, true);
    },
    saveStep9: async function (data) {
        return await carbuyservice.post('/wizard/Step9', data, true);
    },
    saveFollowup: async function (data) {
        return await carbuyservice.post('/followup', data, true)
    },
    saveStepProgress: async function (data) {
        return await carbuyservice.put('/WizardStepProgress', data, true)
    },
    updateFollowup: async function (data) {
        return await carbuyservice.put('/followup', data, true)
    },
    sendEmail: async function (data) {
        return await carbuyservice.put('/email?quoteID=' + data, {}, true);
    },
    sendUPAPHaulerEmail: async function (data) {
        return await carbuyservice.put('/email/upap?quoteID=' + data, {}, true);
    },
    createNewOffer: async function (data) {
        return await carbuyservice.post('/Offer/CreateNewOffer?vehicleID=' + data.vehicleID + '&zipCode=' + data.zipCode + '&userID=' + data.userID, {}, true);
    },
    setQuotePickupLocation: async function (data) {
        return await carbuyservice.put('/QuotePickupLocation', data, true)
    },
    setThirdParty: async function (data) {
        return await carbuyservice.put('/QuoteThirdPartyPartner', data, true)
    },
    updateVehicle: async function (data) {
        return await carbuyservice.put('/vehicle', data, true)
    },
    saveTermCode: async function (data) {
        return await carbuyservice.put('/LiveVox/SaveTermCode', data, true)
    },
    getScreenPop: async (data) => {
        return await carbuyservice.get('/LiveVox/GetScreenPop?sessionID=' + data, {}, true);
    },
    postManualCall: async (data) => {
        var model = { phoneNumber: data.phoneNumber }
        return await carbuyservice.post('/LiveVox/ManualCall?sessionID=' + data.sessionID, model, true);
    },
    saveCallInfo: async (data) => {
        return await carbuyservice.post('/CallInformation', data, true)
    }
}


// WEBPACK FOOTER //
// ./src/api/wizard.js